<script setup lang="ts">
import type { IVacancyCard } from '~/components/entity/vacancy/types'
import { useDateFormat } from '~/composables/useDateTimeFormat'
import { EntityOrganizationLogo } from '~/components/entity/organization-logo'

const props = withDefaults(
  defineProps<{
    item: IVacancyCard
    hideOrganizationDetails?: boolean
  }>(),
  {
    hideOrganizationDetails: false
  }
)

const formattedDate = computed(() => useDateFormat(props.item.updated_at))

// The title may carry the search highlight (<em>); attributes need plain text
const plainTitle = computed(() => useStripTags(props.item.title))
</script>

<template>
  <article class="Card" :class="{ Highlight: props.item.highlight }">
    <div class="EntityCardLayout">
      <div class="flex gap-4">
        <EntityOrganizationLogo
          :src="props.item.organization.logo"
          :alt="props.item.organization.title"
          :to="props.item.organization.url"
          :aria-label="`${$t('common.more_about')} ${props.item.organization.title}`"
        />
        <div>
          <NuxtLinkLocale
            :to="props.item.url"
            :aria-label="`${$t('entity.vacancy.more_about_vacancy')} «${plainTitle}» ${$t('common.from_preposition')} ${props.item.organization.title}`"
            class="inline-block hover:underline"
          >
            <Heading tag="h3" class="hit-title h6"><span v-hydrated-html="props.item.title" /></Heading>
          </NuxtLinkLocale>
          <p v-if="props.item.location" class="text-gray-700">
            {{ props.item.location.title }}
          </p>
        </div>
      </div>

      <div class="grid grid-cols-2 gap-y-2">
        <div>
          <div class="SecondaryTextHeadings">{{ $t('common.organization_label') }}</div>
          <NuxtLinkLocale
            :to="props.item.organization.url"
            :aria-label="`${$t('common.more_about')} ${props.item.organization.title}`"
            class="font-semibold hover:underline"
          >
            {{ props.item.organization.title }}
          </NuxtLinkLocale>
        </div>
        <div>
          <div class="SecondaryTextHeadings">{{ $t('entity.vacancy.publication_date') }}</div>
          <div class="font-semibold">{{ formattedDate }}</div>
        </div>
      </div>
    </div>
  </article>
</template>
